
const PhotoPortfolio = () => {
    return (
        <>
            <h1>
                This is still in development, come back later !
            </h1>
            <img src={require('./images/IMG_1298.JPG')} style={{
                height: 250
            }} />
        </>
    )
}

export default PhotoPortfolio